<template>
  <div class="risk-box">
    <el-form
      style="padding: 20px;"
      :model="riskForm"
      ref="ruleFormRef"
      label-width="220px"
      class="ruleForm rmgt"
      :disabled="formDisabled"
      :key="collectionType"
    >
      <div class="risk-tips">
        <el-alert
          :closable="false"
          title=" 注：风控规则由平台保留最终解释权，所有风控内容最终以平台设置的可调范围为准。"
          type="warning"
        ></el-alert>
      </div>
      <el-form-item required label="执行者年龄区间：">
        <el-input disabled :value="riskForm.ageStart" placeholder="">
          <span disabled slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input disabled :value="riskForm.ageEnd" placeholder="">
          <span disabled slot="suffix">岁</span>
        </el-input>
      </el-form-item>
      <el-form-item
        required
        label="执行任务时间："
        prop="startTime"
        :rules="
          validVisitTime(
            ruleForm.startTime,
            ruleForm.endTime,
            riskForm.startTime,
            riskForm.endTime,
            updateVerify
          )
        "
      >
        <div class="task-times">
          <el-time-select
            :disabled="ruleForm.startEndTimeIsUpdate"
            required
            :picker-options="pickerOptionsStart"
            v-model="riskForm.startTime"
          ></el-time-select>
          <div><span class="task-line"></span></div>
          <el-time-select
            :disabled="ruleForm.startEndTimeIsUpdate"
            required
            :picker-options="pickerOptionsEnd"
            v-model="riskForm.endTime"
          ></el-time-select>
        </div>
      </el-form-item>
      <div style="margin-top: 20px;" class="cut-off-rule"></div>
      <el-form-item v-if="collectionType != 2" label="项目执行人：">
        <div style="display: flex;">
          <div>
            <div class="task-time">
              <el-form-item prop="projectMonth">
                <el-input value="1" disabled>
                  <span slot="suffix">
                    自然月内
                  </span>
                </el-input>
              </el-form-item>
              <div class="operability">可提交</div>
              <el-form-item
                :rules="
                  ValidatorMaysBumit(0, ruleForm.selfMonthNumber, updateVerify)
                "
                prop="selfMonthNumber"
              >
                <el-input
                  :disabled="ruleForm.selfDayNumberIsUpdate"
                  placeholder="不限"
                  v-model.number="riskForm.selfMonthNumber"
                  clearable
                  :maxlength="9"
                >
                  <span slot="suffix">次</span>
                </el-input>
              </el-form-item>
            </div>
            <div class="task-time" style="margin-bottom: 0;">
              <el-form-item prop="projectDay">
                <el-input value="1" disabled>
                  <span slot="suffix">
                    天内
                  </span>
                </el-input>
              </el-form-item>
              <div class="operability">可提交</div>
              <el-form-item
                :rules="
                  ValidatorMaysBumit(0, ruleForm.selfDayNumber, updateVerify)
                "
                prop="selfDayNumber"
              >
                <el-input
                  :disabled="ruleForm.selfDayNumberIsUpdate"
                  placeholder="不限"
                  v-model.number="riskForm.selfDayNumber"
                  clearable
                  :maxlength="9"
                >
                  <span slot="suffix">次</span>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="haveTimeSubject == 1 && collectionType != 2"
        :key="haveTimeSubject"
        required
        label="服务发生时间："
        prop="selfSurveyStartTime"
        :rules="
          validVisitTime(
            ruleForm.selfSurveyStartTime,
            ruleForm.selfSurveyEndTime,
            riskForm.selfSurveyStartTime,
            riskForm.selfSurveyEndTime,
            updateVerify,
            '服务发生时间'
          )
        "
      >
        <div class="task-times">
          <el-time-select
            :disabled="ruleForm.selfSurveyTimeIsUpdate"
            required
            :picker-options="pickerOptionsStart"
            v-model="riskForm.selfSurveyStartTime"
          ></el-time-select>
          <div><span class="task-line"></span></div>
          <el-time-select
            :disabled="ruleForm.selfSurveyTimeIsUpdate"
            required
            :picker-options="pickerOptionsEnd"
            v-model="riskForm.selfSurveyEndTime"
          ></el-time-select>
        </div>
      </el-form-item>
      <el-form-item
        v-if="haveTimeSubject == 1 && collectionType != 2"
        :rules="validSurveyIntervalTime(ruleForm.surveyIntervalTime)"
        label="服务时间最低间隔："
        prop="surveyIntervalTime"
        :key="haveTimeSubject"
      >
        <el-input
          :disabled="ruleForm.surveyIntervalTimeIsUpdate"
          style="width: 399px;"
          v-model="riskForm.surveyIntervalTime"
          placeholder="请输入最低间隔"
        >
          <span disabled slot="suffix">分钟</span>
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="havePositionSubject == 1 && collectionType != 2"
        :rules="validTaskMoveSpeed(ruleForm.taskMoveSpeed)"
        label="任务移动速度："
        prop="taskMoveSpeed"
        :key="havePositionSubject"
      >
        <div style="display: flex;justify-content: space-between;width: 399px;">
          <div>
            <span v-html="`平均移动速度≤`"></span>
            <el-input
              :disabled="ruleForm.taskMoveSpeedIsUpdate"
              v-model="riskForm.taskMoveSpeed"
              placeholder="请输入平均移动速度"
              style="margin-left: 10px; width: 276px;"
            >
              <span slot="suffix">KM/h</span>
            </el-input>
          </div>
        </div>
      </el-form-item>
      <div class="cut-off-rule" v-if="collectionType != 2"></div>
      <el-form-item label="被分享人：" v-if="collectionType != 1">
        <div style="display: flex;">
          <div>
            <div class="task-time">
              <el-form-item prop="sharerMonth">
                <el-input value="1" disabled>
                  <span slot="suffix">
                    自然月内
                  </span>
                </el-input>
              </el-form-item>
              <div class="operability">可提交</div>
              <el-form-item
                :rules="
                  ValidatorMaysBumit(
                    0,
                    ruleForm.shareMonthNumber,

                    updateVerify
                  )
                "
                prop="shareMonthNumber"
              >
                <el-input
                  :disabled="ruleForm.shareDayNumberIsUpdate"
                  placeholder="不限"
                  v-model.number="riskForm.shareMonthNumber"
                  clearable
                  :maxlength="9"
                >
                  <span slot="suffix">次</span>
                </el-input>
              </el-form-item>
            </div>
            <div class="task-time" style="margin-bottom: 0;">
              <el-form-item prop="sharerDay">
                <el-input value="1" disabled>
                  <span slot="suffix">
                    天内
                  </span>
                </el-input>
              </el-form-item>
              <div class="operability">可提交</div>
              <el-form-item
                :rules="
                  ValidatorMaysBumit(0, ruleForm.shareDayNumber, updateVerify)
                "
                prop="shareDayNumber"
              >
                <el-input
                  :disabled="ruleForm.shareDayNumberIsUpdate"
                  placeholder="不限"
                  v-model.number="riskForm.shareDayNumber"
                  clearable
                  :maxlength="9"
                >
                  <span slot="suffix">次</span>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="haveTimeSubject == 1 && collectionType != 1"
        required
        label="服务发生时间："
        prop="shareSurveyStartTime"
        :rules="
          validVisitTime(
            ruleForm.shareSurveyStartTime,
            ruleForm.shareSurveyEndTime,
            riskForm.shareSurveyStartTime,
            riskForm.shareSurveyEndTime,
            updateVerify,
            '服务发生时间'
          )
        "
      >
        <div class="task-times">
          <el-time-select
            :disabled="ruleForm.shareSurveyTimeIsUpdate"
            required
            :picker-options="pickerOptionsStart"
            v-model="riskForm.shareSurveyStartTime"
          ></el-time-select>
          <div><span class="task-line"></span></div>
          <el-time-select
            :disabled="ruleForm.shareSurveyTimeIsUpdate"
            required
            :picker-options="pickerOptionsEnd"
            v-model="riskForm.shareSurveyEndTime"
          ></el-time-select>
        </div>
      </el-form-item>
      <div class="cut-off-rule" v-if="collectionType != 1"></div>
      <el-form-item
        v-if="collectionType == 1"
        required
        prop="intervalTime"
        :rules="ValidatorMinimumTime(ruleForm.intervalTime, 60, updateVerify)"
        label="任务最低间隔时间："
      >
        <div class="task-min-time">
          <el-input
            :disabled="ruleForm.intervalTimeIsUpdate"
            v-model.number="riskForm.intervalTime"
            clearable
            :maxlength="2"
          >
            <span slot="suffix">分钟</span>
          </el-input>
          <span class="task-min-time-tip">
            注：当前任务提交时间与下个任务开始时间的间隔，
            <br />
            &emsp;&emsp;请根据企业实际情况进行调整
          </span>
        </div>
      </el-form-item>

      <el-form-item>
        <div style="font-size: 13px;margin-left: 40px;">
          <p>注：1. 您可根据实际执行要求修改风控信息</p>
          <p style="margin-left: 30px;">
            2.第一次修改后将会立即生效，此后修改新的风控标准将于次日
            <span style="color: red;">00:00</span>
            生效
          </p>
        </div>
      </el-form-item>
      <el-form-item></el-form-item>
    </el-form>
    <div
      style="padding-left: 320px;margin-bottom: 20px; background-color: #fff; padding-bottom: 20px;"
    >
      <template v-if="editSaveBtn">
        <el-button
          v-if="btnShow"
          type="primary"
          :loading="saveLoading"
          plain
          @click="edit"
        >
          编辑
        </el-button>
        <el-button v-else type="primary" :loading="saveLoading" @click="save">
          保存
        </el-button>
      </template>

      <el-button
        :loading="saveLoading"
        type="primary"
        @click="riskControlRecord"
      >
        风控记录
      </el-button>
    </div>
    <riskControlRecordListModel
      ref="riskControlRecordListModel"
      :visible.sync="visible"
      :projectId="projectId"
    ></riskControlRecordListModel>
  </div>
</template>

<script>
import { makeSure } from '@/Mixin/makeSure';
import riskControlRecordListModel from '../components/riskControlRecordListModel/riskControlRecordListModel.vue';
import { riskControl } from '@/api/ajax';
export default {
  mixins: [makeSure],
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: function() {
        return {};
      }
    },

    listobj: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      haveTimeSubject: 0, //
      havePositionSubject: 0, //
      editSaveBtn: true,
      updateVerify: false,
      whether: {}, //是否可调
      collectionType: 3,
      ruleNumber: 999,
      projectId: this.$route.query.id,
      globalData: {}, //全局数据
      btnShow: true, //编辑/保存
      formDisabled: true, //禁用整个表单
      visible: false,
      saveLoading: false,
      riskForm: {
        ageStart: '', //年龄区间-开始
        ageEnd: '', //年龄区间-结束
        startTime: '', //任务执行时间范围-开始
        endTime: '', //任务执行时间范围-结束
        startEndTimeIsUpdate: '', //任务执行时间范围乙方可调：0-不可调，1-可调
        selfDayNumber: '', //自答-日最大可提交数，null表示不限
        selfDayNumberIsUpdate: '', //自答-日最大可提交数乙方可调：0-不可调，1-可调
        selfMonthNumber: '', //自答-月最大可提交数，null表示不限
        selfMonthNumberIsUpdate: '', //自答-月最大可提交数乙方可调：0-不可调，1-可调
        shareDayNumber: '', //分享-日最大可提交数，null表示不限
        shareDayNumberIsUpdate: '', //分享-日最大可提交数乙方可调：0-不可调，1-可调
        shareMonthNumber: '', //分享-月最大可提交数，null表示不限
        shareMonthNumberIsUpdate: '', //分享-月最大可提交数乙方可调：0-不可调，1-可调
        intervalTime: '', //任务最低间隔时间
        intervalTimeIsUpdate: '', //任务最低间隔时间乙方可调：0-不可调，1-可调
        isEnable: 1, //是否生效：0-未生效，1-已生效
        enableDt: 1678927896000, //生效时间
        selfSurveyStartTime: '', //自答-开始时间，必填
        selfSurveyEndTime: '', //自答-结束时间，必填
        surveyIntervalTime: '' //服务发生时间最低间隔（分）
      },
      ruleForm: {
        startEndTimeIsUpdate: false,
        selfDayNumberIsUpdate: false,
        shareDayNumberIsUpdate: false,
        intervalTimeIsUpdate: false,
        selfSurveyTimeIsUpdate: false, //自答 服务发生时间乙方是否可修改(0-不可修改，1-可修改)
        surveyIntervalTimeIsUpdate: false, //服务发生时间最低间隔是否可修改(0-不可修改，1-可修改)
        shareSurveyTimeIsUpdate: false //分享 服务发生时间乙方是否可修改(0-不可修改，1-可修改)
      }
    };
  },

  components: {
    riskControlRecordListModel
  },
  computed: {
    validTaskMoveSpeed() {
      return speed => {
        return [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (+value > +speed && ![null, undefined, ''].includes(speed)) {
                callback(`任务移动速度不能大于${speed}`);
              }
              if (Number.isNaN(+value)) {
                callback('请输入数字');
              } else if (!value && value !== 0) {
                callback('请输入');
              } else if (!/^[0-9]\d*$/.test(value)) {
                callback('需为正整数，请调整');
              } else if (value > 120) {
                callback('移动速度最大120KM/小时');
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ];
      };
    },
    pickerOptionsStart() {
      return {
        start: '00:00',
        step: '00:01',
        end: '23:59'
      };
    },
    pickerOptionsEnd() {
      return {
        start: '00:00',
        step: '00:01',
        end: '23:59'
      };
    },
    validSurveyIntervalTime() {
      return time => {
        return [
          {
            required: true,
            validator: (rule, value, callback) => {
              if ([undefined, '', null].includes(value)) {
                callback('请输入最低间隔');
              } else {
                if (value < 1 || value > 60) {
                  callback('输入范围 1-60，请调整');
                }
                if (value < time && ![null, undefined, ''].includes(time)) {
                  callback(`最低间隔不能小于${time}`);
                }
                if (!/^[0-9]\d*$/.test(value)) {
                  callback('需为正整数，请调整');
                } else {
                  callback();
                }
              }
            },
            trigger: 'blur'
          }
        ];
      };
    },

    validVisitTime() {
      return (min, max, nowMin, nowMax, updateVerify, msg = '任务执行时间') => {
        return [
          {
            validator: (rule, value, callback) => {
              if (updateVerify == false) {
                callback();
              }
              if (!nowMin) {
                callback('请选择开始时间');
              }
              if (!nowMax) {
                callback('请选择结束时间');
              }

              if (nowMin > nowMax) {
                callback('起时间需小于止时间，请调整');
              } else if (nowMin < min) {
                callback(`${msg}不能小于${min}`);
              } else if (nowMax > max) {
                callback(`${msg}不能大于${max}`);
              } else {
                callback();
              }
            },
            trigger: ['blur', 'change']
          }
        ];
      };
    },

    ValidatorMaysBumit() {
      return (min, max, updateVerify) => {
        return [
          {
            validator: (rule, value, callback) => {
              if (updateVerify == false) {
                callback();
              }
              if (
                max !== null &&
                max !== undefined &&
                [undefined, '', null].includes(value)
              ) {
                callback(new Error(`次数最多为${max}次`));
                return;
              }
              if (max !== null && max !== undefined && value > max) {
                callback(new Error(`次数最多为${max}次`));
                return;
              }
              if (
                ![undefined, '', null].includes(value) &&
                !/^[0-9]\d*$/.test(value)
              ) {
                callback('需为正整数，请调整');
                return;
              }

              callback();
            },
            trigger: 'change'
          }
        ];
      };
    },
    ValidatorMinimumTime() {
      return (min, max, updateVerify) => {
        return [
          {
            validator: (rule, value, callback) => {
              if (updateVerify == false) {
                callback();
              }
              if (!/^[0-9]\d*$/.test(value)) {
                callback('需为正整数，请调整');
              } else if (value < min) {
                callback(`设置分钟${min}-${max}分钟`);
              } else if (value > max) {
                callback(`设置分钟必须小于${max}分钟`);
              } else {
                callback();
              }
            },
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if (!/^[0-9]\d*$/.test(value)) {
                callback('需为正整数，请调整');
              } else if (value < min) {
                callback(`设置分钟${min}-${max}分钟`);
              } else if (value > max) {
                callback(`设置分钟必须小于${max}分钟`);
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ];
      };
    }
  },
  methods: {
    edit() {
      this.updateVerify = true;
      this.btnShow = false;
      this.formDisabled = false;
      this.riskForm = Object.assign({}, this.globalData);
    },
    save() {
      this.$refs.ruleFormRef.validate(valid => {
        if (valid) {
          this.$confirm('确定修改?', {
            riskForm: this.riskForm,
            async beforeClose(action, instance, done) {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = '执行中...';
                try {
                  const res = await riskControl.investigate.dcwjRiskSave(
                    this.riskForm
                  );
                  if (+res.data.code == 1) {
                    this.$message({
                      type: 'success',
                      message: '操作成功'
                    });
                    window.location.reload();
                  }

                  done();
                } catch (e) {
                  console.log('err');
                }
                instance.confirmButtonText = '保存';
                instance.confirmButtonLoading = false;
              } else {
                done();
              }
            }
          })
            .then(() => {})
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    riskControlRecord() {
      this.visible = true;
      this.$refs.riskControlRecordListModel.initTabelData();
    }
  },
  mounted() {
    //修改父级的padding
    const dom = Array.from(document.getElementsByClassName('risk'));
    dom[0].style.padding = 0;
  },
  async created() {
    this.saveLoading = true;
    const {
      data: { data }
    } = await riskControl.investigate.dcwjRiskDetail({
      projectId: this.$route.query.id
    });
    this.haveTimeSubject = data.haveTimeSubject; //是否是时刻题
    this.havePositionSubject = data.havePositionSubject; //是否是位置题
    this.collectionType = data.collectionType;
    this.saveLoading = false;
    this.whether['startEndTimeIsUpdate'] =
      data.baseRiskControl.startEndTimeIsUpdate == 1 ? false : true; //任务执行时间范围乙方可调：0-不可调，1-可调
    this.whether['selfDayNumberIsUpdate'] =
      data.baseRiskControl.selfDayNumberIsUpdate == 1 ? false : true; //自答-日最大可提交数乙方可调：0-不可调，1-可调
    this.whether['shareDayNumberIsUpdate'] =
      data.baseRiskControl.shareDayNumberIsUpdate == 1 ? false : true; //分享-日最大可提交数乙方可调：0-不可调，1-可调
    this.whether['intervalTimeIsUpdate'] =
      data.baseRiskControl.intervalTimeIsUpdate == 1 ? false : true; //任务最低间隔时间乙方可调：0-不可调，1-可调

    //新加服务发生时间、调研最低间隔、任务移动速度、分享服务发生时间
    this.whether['selfSurveyTimeIsUpdate'] =
      data.baseRiskControl.selfSurveyTimeIsUpdate == 1 ? false : true; //自答 服务发生时间乙方是否可修改(0-不可修改，1-可修改)
    this.whether['surveyIntervalTimeIsUpdate'] =
      data.baseRiskControl.surveyIntervalTimeIsUpdate == 1 ? false : true; //服务发生时间最低间隔是否可修改(0-不可修改，1-可修改)
    this.whether['shareSurveyTimeIsUpdate'] =
      data.baseRiskControl.shareSurveyTimeIsUpdate == 1 ? false : true; //服务发生时间最低间隔是否可修改(0-不可修改，1-可修改)
    this.whether['taskMoveSpeedIsUpdate'] =
      data.baseRiskControl.taskMoveSpeedIsUpdate == 1 ? false : true;

    this.globalData =
      data.saasRiskControlDisable ||
      data.saasRiskControlEnable ||
      data.baseRiskControl;
    this.riskForm = Object.assign(
      {},
      data.saasRiskControlEnable || data.baseRiskControl
    );
    this.ruleForm = Object.assign({}, data.baseRiskControl, this.whether);
    this.riskForm['ageStart'] = data.baseRiskControl.ageStart;
    this.riskForm['ageEnd'] = data.baseRiskControl.ageEnd;
    this.globalData['ageStart'] = data.baseRiskControl.ageStart;
    this.globalData['ageEnd'] = data.baseRiskControl.ageEnd;

    //判断编辑按钮和保存按钮的显示与隐藏
    //1.项目执行人和任务最低间隔时间一起显示 1 selfDayNumberIsUpdate  intervalTimeIsUpdate
    //2.被分享人显示2                        shareDayNumberIsUpdate
    //3.项目执行人和被分享人显示 3            selfDayNumberIsUpdate  shareDayNumberIsUpdate
    if (this.collectionType == 1) {
      if (
        this.whether.selfDayNumberIsUpdate &&
        this.whether.intervalTimeIsUpdate &&
        this.whether.startEndTimeIsUpdate
      ) {
        this.editSaveBtn = false;
      }
    } else if (this.collectionType == 2) {
      if (
        this.whether.shareDayNumberIsUpdate &&
        this.whether.startEndTimeIsUpdate
      ) {
        this.editSaveBtn = false;
      }
    } else {
      if (
        this.whether.selfDayNumberIsUpdate &&
        this.whether.shareDayNumberIsUpdate &&
        this.whether.startEndTimeIsUpdate
      ) {
        this.editSaveBtn = false;
      }
    }
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 25px;
  display: inline-block;
}

.task-line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 30px;
  display: inline-block;
}

.task-times {
  display: flex !important;
  ::v-deep {
    .el-input__icon {
      color: #c0c4cc;
    }
  }
}

.task-time {
  display: flex !important;
  margin-bottom: 20px;
}

.cut-off-rule {
  width: 800px;
  height: 1px;
  background: #dedede;
  margin-bottom: 20px;
  margin-top: -10px;
}

.operability {
  margin: 0 20px;
  font-size: 13px;
}

.tip-text {
  text-align: center;
}

.default {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.default-range {
  margin-left: 100px;
}

.marg20 {
  margin-bottom: 20px;
}

.task-min-time {
  display: flex;
  align-items: center;

  &-tip {
    display: inline-block;
    line-height: 18px;
    margin-left: 20px;
    font-size: 13px;
  }

  &-default {
    margin-left: 18px;
  }
}
</style>
